import styled from '@emotion/styled';

export const Description = styled.div((props) => ({
  fontSize: 13,
  fontWeight: 400,
  fontStyle: 'italic',
  fontFamily: props.theme.fonts.primary,
}));
